document.addEventListener('DOMContentLoaded', function () {
  var range = document.getElementById('zd-compareRange');
  var after = document.getElementById('zd-afterLayer');
  var handle = document.getElementById('zd-handleLine');
  var grip = document.getElementById('zd-grip');
  var navToggle = document.getElementById('zd-navToggle');
  var navLinks = document.getElementById('zd-navLinks');

  if (range && after && handle && grip) {
    function update(v) {
      after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      handle.style.left = v + '%';
      grip.style.left = v + '%';
    }
    range.addEventListener('input', function (e) { update(e.target.value); });
    update(50);
  }

  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function () {
      navLinks.classList.toggle('open');
    });
  }

  var form = document.getElementById('zd-contact-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var note = form.querySelector('.zd-submit-note');
      if (note) note.style.display = 'block';
    });
  }
});
